import { Info } from "lucide-react";
import type { ReactNode } from "react";

/**
 * Inline compliance qualifier rendered at the point of a tax or
 * guarantee statement, so a reader never has to reach the footer
 * disclaimer to see it.
 *
 * Authored in lesson markdown as a blockquote prefixed with "NOTE:".
 */
export function LessonCallout({ children }: { children: ReactNode }) {
  return (
    <aside
      className="not-prose my-6 flex gap-3 border-l-2 border-bronze-600 bg-bronze-600/5 px-4 py-3"
      style={{ borderRadius: 2 }}
    >
      <Info
        className="mt-0.5 h-4 w-4 shrink-0 text-bronze-600"
        strokeWidth={1.8}
        aria-hidden
      />
      <p className="min-w-0 font-sans text-[13px] leading-[1.6] text-charcoal-900">
        {children}
      </p>
    </aside>
  );
}

export default LessonCallout;
